export default "__VITE_ASSET__CYGVk9bg__"